<template>
    <div class="user-add-wrap-out">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="doctorAdd-wrap" v-loading="loading">
            <div class="doctor-title">
                <i class="iconfont icon-tongyongbiaotiicon"></i
                ><span>医生信息</span>
            </div>
            <el-form :model="ruleForm" ref="ruleForm" class="rule-from">
                <div class="doctor-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label-width="16px">
                                <div class="avart-wrap">
                                    <!-- 遮罩 -->
                                    <div class="cover-custom" v-show="imageUrl">
                                        <div class="cover-wrap">
                                            <i
                                                class="el-icon-zoom-in"
                                                @click="avartIn"
                                            ></i>
                                            <i
                                                class="el-icon-delete"
                                                @click="avartDele"
                                            ></i>
                                        </div>
                                    </div>
                                    <el-upload
                                        class="avatar-uploader"
                                        action=""
                                        :auto-upload="false"
                                        :show-file-list="false"
                                        list-type="picture-card"
                                        :http-request="uploadFile"
                                        :on-change="changeUpload"
                                        accept="image/jpeg,image/jpg,image/png"
                                    >
                                        <img
                                            v-if="imageUrl"
                                            :src="imageUrl"
                                            class="avatar-show"
                                        />
                                        <div else class="avatar-img">
                                            <i class="iconfont icon-camera"></i>
                                            <div class="uploader-title">
                                                上传头像
                                            </div>
                                        </div>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="姓名"
                                label-width="104px"
                                prop="accountName"
                                :rules="[
                                    { required: true, message: '请输入姓名' }
                                ]"
                            >
                                <el-input
                                    v-model.trim="ruleForm.accountName"
                                    placeholder="请输入姓名"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="身份证号"
                                label-width="104px"
                                prop="idCard"
                                :required="false"
                                :rules="[
                                    {
                                        required: false,
                                        message: '请输入身份证号',
                                        trigger: 'blur'
                                    },
                                    {
                                        required: false,
                                        message: '请输入身份证号',
                                        trigger: 'change'
                                    },
                                    {
                                        required: false,
                                        validator: checkId,
                                        trigger: 'blur'
                                    },
                                    {
                                        required: false,
                                        validator: checkId,
                                        trigger: 'change'
                                    }
                                ]"
                            >
                                <el-input
                                    v-model.trim="ruleForm.idCard"
                                    placeholder="请输入身份证号"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="学历"
                                label-width="104px"
                                prop="hospitalName"
                            >
                                <el-select
                                    v-model="ruleForm.educationBackgroundCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleEducationChange"
                                    @clear="handleEducationChange"
                                    placeholder="请选择学历"
                                >
                                    <el-option
                                        v-for="(item, index) in educationList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="性别"
                                label-width="104px"
                                prop="accountSex"
                            >
                                <el-radio-group v-model="ruleForm.accountSex">
                                    <el-radio label="1">男</el-radio>
                                    <el-radio label="0">女</el-radio>
                                    <el-radio label="2">未知</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                label="登录手机号"
                                label-width="104px"
                                prop="phone"
                                :rules="[
                                    {
                                        required: true,
                                        message: '请输入登录手机号'
                                    },
                                    {
                                        pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                                        required: true,
                                        message: '请输入正确的登录手机号'
                                    }
                                ]"
                            >
                                <el-input
                                    v-model.trim="ruleForm.phone"
                                    placeholder="请输入登录手机号"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div class="doctor-base-info">
                    <div class="info-title">执业信息</div>
                    <el-row>
                        <el-col :span="8" class="auto-select">
                            <el-form-item
                                label="医院"
                                label-width="88px"
                                prop="hospitalId"
                                :rules="[
                                    { required: true, message: '请输入医院' }
                                ]"
                            >
                                <el-select
                                    filterable
                                    clearable
                                    remote
                                    :disabled="haveDept"
                                    :remote-method="getHospital"
                                    :loading="isSearchDept"
                                    loading-text="正在搜索医院，请稍后..."
                                    v-model="ruleForm.hospitalId"
                                    placeholder="请输入关键字搜索"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleHosChange"
                                    @clear="handleHosChange"
                                >
                                    <el-option
                                        :label="item.hospitalName"
                                        :value="item.hospitalId"
                                        v-for="(item, index) in hospitalList"
                                        :key="index"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="医生集团" label-width="88px">
                                <el-select
                                    multiple
                                    filterable
                                    remote
                                    :style="{ width: '210px' }"
                                    :disabled="haveDept"
                                    :remote-method="getGroup"
                                    :loading="isSearchDept"
                                    loading-text="正在搜索医生集团，请稍后..."
                                    v-model="ruleForm.groupIds"
                                    placeholder="请输入关键字搜索"
                                    size="small"
                                >
                                    <el-option
                                        v-for="item in gropList"
                                        :label="item.groupName"
                                        :value="item.groupId"
                                        :key="item.groupId"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="科室"
                                label-width="104px"
                                prop="departmentId"
                                :rules="[
                                    { required: true, message: '请选择科室' }
                                ]"
                            >
                                <!-- <el-select filterable
                                           clearable
                                           remote
                                           :disabled="haveDept"
                                           :remote-method="getDepart"
                                           :loading="isSearchDept"
                                           loading-text="正在搜索科室，请稍后..."
                                           v-model="ruleForm.departmentId"
                                           placeholder="请输入关键字搜索"
                                           :style="{width: '210px'}"
                                           popper-class="deptSelect"
                                           size="small">
                                    <el-option :label="item.groupName"
                                               :value="item.groupId"
                                               v-for="(item, index) in departList"
                                               :key="index"></el-option>
                                </el-select> -->
                                <el-cascader
                                    class="form-cas-select"
                                    size="small"
                                    :style="{ width: '210px' }"
                                    v-model="ruleForm.departmentId"
                                    placeholder="请选择科室"
                                    :options="departList"
                                    :props="defaultProps"
                                    @focus="isHaveHospital"
                                    :visible-arrow="false"
                                    clearable
                                    filterable
                                ></el-cascader>
                            </el-form-item>
                            <el-form-item
                                label="职称"
                                label-width="104px"
                                prop="titleCode"
                                :rules="[
                                    { required: true, message: '请选择职称' }
                                ]"
                            >
                                <el-select
                                    v-model="ruleForm.titleCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleTitleChange"
                                    @clear="handleTitleChange"
                                    placeholder="请选择职称"
                                >
                                    <el-option
                                        v-for="(item, index) in doctorJobList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="auto-select">
                            <el-form-item
                                label="工号"
                                label-width="104px"
                                prop="accountNumber"
                            >
                             <!-- :rules="[
                                    { required: true, message: '请输入工号' }
                                ]"
                                v-if="searchHospitalId === '34'" -->
                                <el-input
                                    v-model.trim="ruleForm.accountNumber"
                                    placeholder="请输入工号"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="教职"
                                label-width="104px"
                                prop="educationCode"
                            >
                                <el-select
                                    v-model="ruleForm.educationCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleEduChange"
                                    @clear="handleEduChange"
                                    placeholder="请选择教职"
                                >
                                    <el-option
                                        v-for="(item, index) in facultyList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8" class="auto-select">
                            <el-form-item
                                label="角色"
                                label-width="88px"
                                prop="roleIds"
                            >
                                <el-select
                                    v-model="ruleForm.roleIds"
                                    multiple
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    placeholder="请选择角色"
                                >
                                    <el-option
                                        v-for="(item, index) in roleList"
                                        :key="index"
                                        :label="item.roleName"
                                        :value="item.roleId"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item
                        class="form-details"
                        label="简介"
                        label-width="88px"
                        prop="doctorResume"
                    >
                        <el-input
                            v-model.trim="ruleForm.doctorResume"
                            type="textarea"
                            :style="{ width: '720px', height: '132px' }"
                            placeholder="请输入简介"
                            maxlength="700"
                            show-word-limit
                            class="introduction-detail"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        class="form-details"
                        label="擅长"
                        label-width="88px"
                        prop="doctorSpecial"
                    >
                        <el-input
                            v-model.trim="ruleForm.doctorSpecial"
                            type="textarea"
                            :style="{ width: '720px', height: '132px' }"
                            placeholder="请输入擅长"
                            maxlength="700"
                            show-word-limit
                            class="introduction-detail"
                        ></el-input>
                    </el-form-item>
                </div>
                <div class="doctor-base-info cert-info">
                    <div class="info-title">
                        认证信息<span class="heart-warning"
                            >(提示:建议图片小于10M,图片格式为png、jpg、jpeg)</span
                        >
                    </div>
                    <el-form-item
                        label="身份证正面"
                        label-width="140px"
                        class="item-last"
                        prop="idCardFront"
                        :rules="[
                            { required: false, message: '请上传身份证正面照' }
                        ]"
                        style="border-bottom: 1px dashed #CCCCCC;padding-bottom:20px;"
                    >
                        <el-upload
                            class="papers-uploader"
                            action="/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc"
                            :headers="headers"
                            :on-success="handleCardFrontSuccess"
                            :on-remove="handleCardFrontRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile1"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="sfz_renxiang" />
                        </el-upload>
                        <div class="heart-warning">
                          建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1284px*810px
                        </div>
                    </el-form-item>
                    <div class="form-tips-text">
                        请上传医师注册执业证、执业医师资格证、专业技术资格证、工作证或参会胸牌（至少一项必填）
                    </div>

                    <el-form-item
                        label="工作证或参会胸牌"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="papers-uploader"
                            action="/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc"
                            :headers="headers"
                            :on-success="handleOtherCardSuccess"
                            :on-remove="handleOtherCardRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile2"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="sfz_renxiang" />
                        </el-upload>
                    </el-form-item>

                    <el-form-item
                        label="医师注册执业证"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="papers-uploader"
                            action="/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc"
                            :headers="headers"
                            :on-success="handleRegisterFirstSuccess"
                            :on-remove="handleRegisterFirstRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile3"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_1" />
                        </el-upload>

                        <el-upload
                            class="papers-uploader"
                            action="/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc"
                            :headers="headers"
                            :on-success="handleRegisterSecondSuccess"
                            list-type="picture-card"
                            :on-remove="handleRegisterSecondRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile3"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_" />
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label="执业医师资格证"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="papers-uploader"
                            action="/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc"
                            :headers="headers"
                            :on-success="handleLicenseFirstSuccess"
                            :on-remove="handleLicenseFirstRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile4"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_1" />
                        </el-upload>

                        <el-upload
                            class="papers-uploader"
                            action="/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc"
                            :headers="headers"
                            :on-success="handleLicenseSecondSuccess"
                            list-type="picture-card"
                            :on-remove="handleLicenseSecondRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile4"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_" />
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label="专业技术资格证"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="papers-uploader"
                            action="/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc"
                            :headers="headers"
                            :on-success="handleTechFirstSuccess"
                            :on-remove="handleTechFirstRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile5"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_1" />
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label="电子签名"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="ele-sign"
                            action="/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc"
                            :headers="headers"
                            :on-success="handleSignSuccess"
                            :on-remove="handleSignRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <div class="sign-qian">
                                <svg-icon icon-class="add_img" />
                            </div>
                        </el-upload>
                    </el-form-item>
                </div>
                <!-- 打标签 -->
                <div class="doctor-base-info set-label">
                    <div class="info-title">标签信息</div>
                    <div class="label-wrap">
                        <div class="label-team">
                            <div class="label-team-left">院士团队</div>
                            <div class="label-team-right">
                                <div
                                    class="label-team-select"
                                    @click="showTemaList('tema')"
                                >
                                    <i class="el-icon-circle-plus-outline"></i>
                                    <span>选择团队</span>
                                </div>
                                <div
                                    class="label-team-content"
                                    v-if="temaListShow.length > 0"
                                >
                                    <div
                                        class="team-content-item"
                                        v-for="(item, index) in temaListShow"
                                        :key="index"
                                    >
                                        <i
                                            class="iconfont icon-user1 wow-user"
                                        ></i>
                                        <span>{{ item.name }}</span>
                                        <i
                                            class="el-icon-close wow-close"
                                            @click="
                                                hanldeDeleShow(
                                                    item.groupId,
                                                    index,
                                                    'tema'
                                                )
                                            "
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="label-team">
                            <div class="label-team-left">会诊科室</div>
                            <div class="label-team-right">
                                <div
                                    class="label-team-select"
                                    @click="showTemaList('depart')"
                                >
                                    <i class="el-icon-circle-plus-outline"></i>
                                    <span>选择科室</span>
                                </div>
                                <div
                                    class="label-team-content"
                                    v-if="departListShow.length > 0"
                                >
                                    <div
                                        class="team-content-item"
                                        v-for="(item, index) in departListShow"
                                        :key="index"
                                    >
                                        <span class="wow-folder"></span>
                                        <span>{{ item.name }}</span>
                                        <i
                                            class="el-icon-close wow-close"
                                            @click="
                                                hanldeDeleShow(
                                                    item.groupId,
                                                    index,
                                                    'depart'
                                                )
                                            "
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 打标签结束 -->
            </el-form>
        </div>
        <div class="add-btn-bottom">
            <el-button
                type="warning"
                size="small"
                @click="handleCreate()"
                :disabled="flag"
                >创 建</el-button
            >
            <el-button type="info" size="small" plain @click="cancleCreate()"
                >取 消</el-button
            >
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            width="600px"
            class="ww-pre-dialog"
        >
            <img width="100%" :src="dialogImageUrl" alt="" />
            <span slot="title">
                <el-image
                    class="icon-delete"
                    :src="deleteUrl"
                    @click="handleImgClose"
                >
                </el-image>
            </span>
        </el-dialog>
        <!-- 裁剪图片弹框 -->
        <el-dialog
            :visible.sync="cropperVisible"
            :destroy-on-close="true"
            width="718px"
            title="头像编辑"
            class="ww-dialog"
        >
            <CropperPic
                ref="vueCropper"
                :imgFile="fileImg"
                @uploadFile="uploadFile"
            >
            </CropperPic>
        </el-dialog>
        <el-dialog
            :visible.sync="cropperPrewVisible"
            :show-close="false"
            top="30vh"
            width="400px"
            class="ww-pre-dialog"
        >
            <span slot="title">
                <el-image
                    class="icon-delete"
                    :src="deleteUrl"
                    @click="handleAvartClose"
                >
                </el-image>
            </span>
            <img width="100%" :src="imageUrl" alt="" />
        </el-dialog>
        <!-- 弹框 选择团队 -->
        <el-dialog
            title="选择团队"
            :visible.sync="dialogTeam"
            custom-class="member-wow-dialog"
            :before-close="handleBeforeClose"
            width="560px"
        >
            <div class="member-content">
                <div class="left-wraper">
                    <div class="search-content">
                        <el-input
                            class="search-tema"
                            placeholder="输入团队名称查询"
                            v-model.trim="memberForm.temaName"
                            @keyup.enter.native="queryAddMemberList('tema')"
                        >
                            <i
                                slot="suffix"
                                class="iconfont icon-search"
                                @click="queryAddMemberList('tema')"
                            ></i>
                        </el-input>
                    </div>

                    <div class="dialog-tema-content">
                        <el-checkbox-group
                            v-model="checkedTemas"
                            v-if="temaList.length > 0"
                        >
                            <el-checkbox
                                v-for="item in temaList"
                                :key="item.groupId"
                                :label="item.groupId"
                                @change="changeCheck(item, 'tema')"
                                ><i class="iconfont icon-user1 wow-user"></i
                                >{{ item.name }}</el-checkbox
                            >
                        </el-checkbox-group>
                        <div class="dialog-none-data" v-else>
                            <div>
                                <svg-icon icon-class="none1" />
                            </div>
                            <span>暂无数据</span>
                        </div>
                    </div>
                </div>
                <div class="right-wraper">
                    <div class="content_text">
                        <div class="choose_text">
                            已选择（{{ chooseData.length }}）
                        </div>
                        <div class="empty_text" @click="handleClear('tema')">
                            清空
                        </div>
                    </div>
                    <div class="choose-member">
                        <div
                            v-for="(item, index) in chooseData"
                            :key="index"
                            class="item-member"
                        >
                            <div>
                                <i class="iconfont icon-user1"></i>
                                <label class="member-text">{{
                                    item.name
                                }}</label>
                            </div>
                            <div>
                                <i
                                    class="el-icon-close"
                                    @click="
                                        hanldeDeleMember(item.groupId, index)
                                    "
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="chooseMember('tema')"
                    class="dialog-confirm-btn"
                    >确 定</el-button
                >
                <el-button @click="clearReturn" class="dialog-cancle"
                    >取 消</el-button
                >
            </span>
        </el-dialog>
        <!-- 选择科室 -->
        <el-dialog
            title="选择科室"
            :visible.sync="dialogDepart"
            custom-class="member-wow-dialog"
            :before-close="clearReturnTwo"
            width="560px"
        >
            <div class="member-content">
                <div class="left-wraper">
                    <div class="search-content">
                        <el-input
                            class="search-tema"
                            placeholder="输入科室名称查询"
                            v-model.trim="memberForm.departName"
                            @keyup.enter.native="queryAddMemberList('depart')"
                        >
                            <i
                                slot="suffix"
                                class="iconfont icon-search"
                                @click="queryAddMemberList('depart')"
                            ></i>
                        </el-input>
                    </div>

                    <div class="dialog-tema-content">
                        <el-checkbox-group
                            v-model="checkedDeparts"
                            v-if="dialogDepartList.length > 0"
                        >
                            <el-checkbox
                                v-for="item in dialogDepartList"
                                :key="item.groupId"
                                :label="item.groupId"
                                @change="changeCheck(item, 'depart')"
                                ><img
                                    class="depart-icon"
                                    src="../../../assets/imgs/folder.png"
                                    alt=""
                                />{{ item.name }}</el-checkbox
                            >
                        </el-checkbox-group>
                        <div class="dialog-none-data" v-else>
                            <div>
                                <svg-icon icon-class="none1" />
                            </div>
                            <span>暂无数据</span>
                        </div>
                    </div>
                </div>
                <div class="right-wraper">
                    <div class="content_text">
                        <div class="choose_text">
                            已选择（{{ chooseDataTwo.length }}）
                        </div>
                        <div class="empty_text" @click="handleClear('depart')">
                            清空
                        </div>
                    </div>
                    <div class="choose-member">
                        <div
                            v-for="(item, index) in chooseDataTwo"
                            :key="index"
                            class="item-member"
                        >
                            <div>
                                <img
                                    class="depart-icon"
                                    src="../../../assets/imgs/folder.png"
                                    alt=""
                                />
                                <label class="member-text">{{
                                    item.name
                                }}</label>
                            </div>
                            <div>
                                <i
                                    class="el-icon-close"
                                    @click="
                                        hanldeDeleMemberTwo(item.groupId, index)
                                    "
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="chooseMember('depart')"
                    class="dialog-confirm-btn"
                    >确 定</el-button
                >
                <el-button @click="clearReturnTwo" class="dialog-cancle"
                    >取 消</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import { checkCard } from "@/utils/IDCard";
import CropperPic from "@/components/cropperPic";
import { postClinicGroupList } from "@/api/consultation";
import { checkFileSize } from "@/utils/checkFiles";
export default {
    name: "userAdd",
    data() {
        return {
            proFileUploadForm: {},
            defaultProps: {
                emitPath: false,
                label: "groupName",
                value: "groupId"
            },
            flag: false,
            loading: false,
            breadList: [
                { label: "用户管理" },
                { label: "用户列表", path: "/user/userList" },
                { label: "新增医生" }
            ],
            ruleForm: {
                identities: "doctor", // 医生
                hospitalId: "", // 医院id
                hospitalName: "", // 医院名称
                accountHead: "", // 头像
                accountName: "", // 用户姓名
                accountNumber: "", // 用户账号(工号)
                accountSex: "", // 性别
                doctorResume: "", // 简介
                doctorSpecial: "", // 擅长
                educationBackgroundCode: "", // 学历code
                educationBackgroundName: "", // 学历code
                educationCode: "", // 教育职称code
                educationName: "", // 教育职称
                titleName: "", // 职称
                titleCode: "", // 职称code
                idCard: "", // 身份证号
                idCardFront: "", // 身份证图片正面
                otherCard: "", // 工作证或参会胸牌
                medicalLicenseFirst: "", // 医生执照first
                medicalLicenseSecond: "", // 医生执照second
                medicalRegisterFirst: "", // 医生注册first
                medicalRegisterSecond: "", // 医生注册second
                techFirst: "", // 专业技术资格证first
                phone: "", // 手机号
                signatureUrl: "", // 签名
                departmentId: "", // 科室id
                groupIds: [], // 集团id
                roleIds: [] // 角色
            },
            haveDept: false, // 搜索
            isSearchDept: false,
            searchHospitalId: "", // 搜索医院ID 关联科室
            hospitalList: [], // 搜索的医院列表
            departList: [], // 科室列表
            gropList: [], // 集团列表
            roleList: [], // 角色列表
            dialogImageUrl: "", // 预览
            dialogVisible: false, // 预览显示
            // 剪切图片
            fileImg: {},
            cropperVisible: false,
            imageUrl: "",
            ceshiUrl:
                "/ms-hoc-video/v1/image/download?fileName=40cb9fcba2f04219961f96fc3c080303.png",
            cropperPrewVisible: false,
            deleteUrl: require("../../../assets/imgs/delete.png"),
            dialogTeam: false, // 选择团队
            memberForm: {
                temaName: "",
                departName: ""
            },
            temaLoading: false,
            chooseData: [],
            checkedTemas: [],
            temaList: [],
            temaListShow: [],
            dialogDepart: false, // 选择科室
            departLoading: false,
            chooseDataTwo: [],
            checkedDeparts: [],
            dialogDepartList: [],
            departListShow: [],
            educationList: [],
            doctorJobList: [],
            facultyList: []
        };
    },
    components: {
        CropperPic
    },
    updated() {
        if (this.$refs.vueCropper) {
            this.$refs.vueCropper.updateOption();
        }
    },
    computed: {
        ...mapGetters(["dictionary", "userInfo"]),
        headers() {
            return { Authorization: "Bearer " + getToken() + "" || undefined };
        }
    },
    mounted() {
        this.getSelect();
    },
    methods: {
        // 上传图片之前 限制
        beforeUploadProfile1(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(file, this,2,'建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1284px*810px');
        },
           beforeUploadProfile2(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(file, this,2,'建议图片小于2M，图片格式为png、jpg、jpeg');
        },
           beforeUploadProfile3(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(file, this,2,'建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1260px*890px');
        },
           beforeUploadProfile4(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(file, this,2,'建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1260px*890px');
        },
          beforeUploadProfile5(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(file, this,2,'建议图片小于2M，图片格式为png、jpg、jpeg');
        },
          beforeUploadProfile(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(file, this,1,'建议图片小于1M，图片格式为png、jpg、jpeg');
        },
        // 选择团队
        handleBeforeClose(done) {
            this.clearReturn();
            done();
        },
        handleBeforeCloseTwo(done) {
            this.clearReturnTwo();
            done();
        },
        // 清除信息团队
        clearReturn() {
            this.memberForm.temaName = "";
            this.chooseData = JSON.parse(JSON.stringify(this.temaListShow));
            this.checkedTemas = [];
            this.dialogTeam = false;
            this.temaListShow.forEach((item, index) => {
                this.checkedTemas.push(item.groupId);
            });
        },
        // 清除信息科室
        clearReturnTwo() {
            this.memberForm.departName = "";
            this.chooseDataTwo = JSON.parse(
                JSON.stringify(this.departListShow)
            );
            this.checkedDeparts = [];
            this.dialogDepart = false;
            this.departListShow.forEach((item, index) => {
                this.checkedDeparts.push(item.groupId);
            });
        },
        queryAddMemberList(type) {
            if (type === "tema") {
                this.getTemaList();
            } else if (type === "depart") {
                this.getDepartList();
            }
        },
        handleClear(type) {
            if (type === "tema") {
                this.chooseData = [];
                this.checkedTemas = [];
            } else {
                this.chooseDataTwo = [];
                this.checkedDeparts = [];
            }
        },
        chooseMember(type) {
            this.memberForm.temaName = "";
            this.memberForm.departName = "";
            if (type === "tema") {
                this.temaListShow = JSON.parse(JSON.stringify(this.chooseData));
                this.dialogTeam = false;
            } else {
                this.departListShow = JSON.parse(
                    JSON.stringify(this.chooseDataTwo)
                );
                this.dialogDepart = false;
            }
        },
        changeCheck(val, type) {
            if (type === "tema") {
                this.changeRightNow(val);
            } else {
                this.changeRightNowTwo(val);
            }
        },
        // 团队修改右侧
        changeRightNow(val) {
            let chooseId = this.checkedTemas;
            if (chooseId.indexOf(val.groupId) !== -1) {
                chooseId.forEach((choose, index) => {
                    if (val.groupId === choose) {
                        this.chooseData.push(val);
                    }
                });
            } else {
                this.chooseData.forEach((item, index) => {
                    if (val.groupId === item.groupId) {
                        this.chooseData.splice(index, 1);
                    }
                });
            }
        },
        // 科室修改右侧
        changeRightNowTwo(val) {
            let chooseId = this.checkedDeparts;
            if (chooseId.indexOf(val.groupId) !== -1) {
                chooseId.forEach((choose, index) => {
                    if (val.groupId === choose) {
                        this.chooseDataTwo.push(val);
                    }
                });
            } else {
                this.chooseDataTwo.forEach((item, index) => {
                    if (val.groupId === item.groupId) {
                        this.chooseDataTwo.splice(index, 1);
                    }
                });
            }
        },
        // 团队确定
        hanldeDeleMember(groupId, index) {
            let chooseId = this.checkedTemas;
            chooseId.forEach((item, key) => {
                if (item === groupId) {
                    this.checkedTemas.splice(key, 1);
                }
            });
            this.chooseData.splice(index, 1);
        },
        // 科室确定
        hanldeDeleMemberTwo(groupId, index) {
            let chooseId = this.checkedDeparts;
            chooseId.forEach((item, key) => {
                if (item === groupId) {
                    this.checkedDeparts.splice(key, 1);
                }
            });
            this.chooseDataTwo.splice(index, 1);
        },
        // 列表删除
        hanldeDeleShow(groupId, index, type) {
            if (type === "tema") {
                this.temaListShow.splice(index, 1);
                this.hanldeDeleMember(groupId, index);
            } else {
                this.departListShow.splice(index, 1);
                this.hanldeDeleMemberTwo(groupId, index);
            }
        },
        showTemaList(type) {
            if (type === "tema") {
                this.dialogTeam = true;
                this.getTemaList();
            } else {
                this.dialogDepart = true;
                this.getDepartList();
            }
        },
        // 获取团队列表
        async getTemaList() {
            this.temaLoading = true;
            let params = {
                state: "ONLINE",
                type: "EXPERTER",
                page: 1,
                size: 1000
            };
            if (this.memberForm.temaName) {
                params.name = this.memberForm.temaName;
            }
            const { results, state } = await postClinicGroupList(params);
            if (results && state === 200) {
                this.temaList = results;
            }
            this.temaLoading = false;
        },
        // 选择团队结束
        // 选择会诊 科室----------------
        // 获取科室列表
        async getDepartList() {
            this.departLoading = true;
            let params = {
                state: "ONLINE",
                type: "DEPT",
                page: 1,
                size: 1000
            };
            if (this.memberForm.departName) {
                params.name = this.memberForm.departName;
            }
            const { results, state } = await postClinicGroupList(params);
            if (results && state === 200) {
                this.dialogDepartList = results;
            }
            this.departLoading = false;
        },
        // 选择会诊 科室 结束
        // 处理下拉列表
        getSelect() {
            this.doctorJobList = this.dictionary.ZC;
            this.educationList = this.dictionary.XL;
            this.facultyList = this.dictionary.JZ;
            this.getRole();
        },
        async getRole() {
            const { results } = await this.$services.hospital.getRoleList();
            this.roleList = results;
        },
        // 验证身份证
        checkId(rule, value, callback) {
            if (value) {
                if (checkCard(value) === false) {
                    callback(new Error("请输入正确的身份证号"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        // 身份证正面图片上传
        handleCardFrontSuccess(res, file) {
            let data = res.results;
            this.ruleForm.idCardFront = data[0].fileId;
            this.$refs["ruleForm"].validateField("idCardFront");
        },
        // 工作证或参会胸牌
        handleOtherCardSuccess(res, file) {
            let data = res.results;
            this.ruleForm.otherCard = data[0].fileId;
        },
        // 注册第一
        handleRegisterFirstSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalRegisterFirst = data[0].fileId;
        },
        // 注册第二
        handleRegisterSecondSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalRegisterSecond = data[0].fileId;
        },
        // 执照第一
        handleLicenseFirstSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalLicenseFirst = data[0].fileId;
        },
        // 执照第二
        handleLicenseSecondSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalLicenseSecond = data[0].fileId;
        },
        // 专业技术资格证一
        handleTechFirstSuccess(res, file) {
            let data = res.results;
            this.ruleForm.techFirst = data[0].fileId;
        },
        // 签名成功
        handleSignSuccess(res, file) {
            let data = res.results;
            this.ruleForm.signatureUrl = data[0].fileId;
        },
        // 头像上传成功
        handleAvatarSuccess(res, file) {
            let data = res.results;
            this.ruleForm.accountHead = data[0].originPictureId;
        },
        // 身份证正面图片删除
        handleCardFrontRemove(file, fileList) {
            this.ruleForm.idCardFront = "";
        },
        // 工作证或参会胸牌删除
        handleOtherCardRemove(file, fileList) {
            this.ruleForm.otherCard = "";
        },
        // 注册第一删除
        handleRegisterFirstRemove(file, fileList) {
            this.ruleForm.medicalRegisterFirst = "";
        },
        // 注册第二删除
        handleRegisterSecondRemove(file, fileList) {
            this.ruleForm.medicalRegisterSecond = "";
        },
        // 执照第一删除
        handleLicenseFirstRemove(file, fileList) {
            this.ruleForm.medicalLicenseFirst = "";
        },
        // 执照第二删除
        handleLicenseSecondRemove(file, fileList) {
            this.ruleForm.medicalLicenseSecond = "";
        },
        // 专业技术资格证一删除
        handleTechFirstRemove(file, fileList) {
            this.ruleForm.techFirst = "";
        },
        // 签名删除 signatureUrl
        handleSignRemove(file, fileList) {
            this.ruleForm.signatureUrl = "";
        },
        // 医院搜索
        async getHospital(value) {
            this.isSearchDept = true;
            const params = {
                searchName: value
            };
            const {
                results
            } = await this.$services.hospital.getAllHospitalList(params);
            this.isSearchDept = false;
            this.hospitalList = results;
            this.departList = [];
        },
        // 搜索科室
        // async getDepart (value) {
        //     if (!this.searchHospitalId) {
        //         this.$message({
        //             message: '请先输入医院',
        //             customClass: 'hos-message--warning',
        //             iconClass: 'el-icon-warning',
        //             duration: '1000'
        //         })
        //         return
        //     }
        //     this.isSearchDept = true
        //     const params = {
        //         hospitalId: this.searchHospitalId,
        //         searchName: value
        //     }
        //     const { results } = await this.$services.hospital.getAllDeptList(params)
        //     this.isSearchDept = false
        //     this.departList = results
        // },
        isHaveHospital(value) {
            if (!this.searchHospitalId) {
                this.$message({
                    message: "请先输入医院",
                    customClass: "hos-message--warning",
                    iconClass: "el-icon-warning",
                    duration: "1000"
                });
            }
        },
        // 搜索集团
        async getGroup(value) {
            this.gropList = [];
            if (value) {
                this.isSearchDept = true;
                const params = {
                    searchName: value
                };
                const {
                    results
                } = await this.$services.hospital.getAllHospitalGroupList(
                    params
                );
                this.isSearchDept = false;
                this.gropList = results;
            }
        },
        // 创建医生
        handleCreate() {
            let flag1 =
                this.ruleForm.medicalRegisterFirst &&
                this.ruleForm.medicalRegisterSecond;

            let flag2 =
                this.ruleForm.medicalLicenseFirst &&
                this.ruleForm.medicalLicenseSecond;

            let flag3 = this.ruleForm.techFirst;

            let flag4 = this.ruleForm.otherCard;

            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    if (flag1 || flag2 || flag3 || flag4) {
                        this.handlePostDoctor();
                    } else {
                        this.$message({
                            message:
                                "请上传医师注册执业证、执业医师资格证、专业技术资格证、工作证或参会胸牌（至少一项必填）",
                            customClass: "hos-message--warning",
                            iconClass: "el-icon-warning",
                            duration: "3000"
                        });
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 取消创建
        cancleCreate() {
            this.$router.push("/user/userList");
        },
        // 获取 树状 科室
        async getTreeDepart(data) {
            let params = {
                hospitalId: data
            };
            const { results } = await this.$services.hospital.getTreeDeptList(
                params
            );
            this.departList = results;
        },
        // ------------code name----------
        // 添加医院name
        handleHosChange(val) {
            this.searchHospitalId = val;
            this.departList = [];
            this.ruleForm.departmentId = "";
            let obj = {};
            obj = this.hospitalList.find(item => {
                return item.hospitalId === val;
            });
            if (val) {
                this.ruleForm.hospitalName = obj.hospitalName;
                this.getTreeDepart(val);
            } else {
                this.ruleForm.hospitalName = "";
            }
        },
        // 教育职称name
        handleEduChange(val) {
            let obj = {};
            obj = this.facultyList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.educationName = obj.dictDataValue;
            } else {
                this.ruleForm.educationName = "";
            }
        },
        // 学历name
        handleEducationChange(val) {
            let obj = {};
            obj = this.educationList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.educationBackgroundName = obj.dictDataValue;
            } else {
                this.ruleForm.educationBackgroundName = "";
            }
        },
        // 职称name
        handleTitleChange(val) {
            let obj = {};
            obj = this.doctorJobList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.titleName = obj.dictDataValue;
            } else {
                this.ruleForm.titleName = "";
            }
        },
        // ------------code name------------------
        // 请求接口创建医生
        async handlePostDoctor() {
            this.loading = true;
            this.flag = true;
            let param = this.ruleForm;
            // 如果打了标签
            param.clinicExperterGroupIds = this.checkedTemas;
            param.clinicDeptGroupIds = this.checkedDeparts;
            // 打标签参数结束
            const {
                results,
                state,
                subMsg
            } = await this.$services.hospital.addDoctor(param);
            this.loading = false;
            this.flag = false;
            if (state !== 200) {
                this.$message({
                    message: subMsg,
                    type: "warning"
                });
            }
            if (state === 200 && results) {
                this.$message({
                    message: "创建医生成功",
                    customClass: "hos-message--success",
                    iconClass: "el-icon-success",
                    duration: "1000"
                });
                this.$router.push("/user/userList");
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 剪切提交图片-------
        changeUpload(file, fileList) {
            console.log(file, file);
            if (file && file.size / 1024 / 1024 > 1) {
                return this.$message.warning(
                    "建议图片小于1M，图片格式为png、jpg、jpeg，图片尺寸建议500px*500px"
                );
            }
            this.fileImg = file;
            this.cropperVisible = true;
        },
        // 提交图片
        async uploadFile(data) {
            let hospitalId = this.userInfo.hospitalId;
            let iuid = this.userInfo.iuid;
            let formData = new FormData();
            formData.append("file", data);
            const { results, state } = await this.$services.hospital.imgUpload(
                formData,
                hospitalId,
                iuid
            );

            if (state === 200 && results) {
                this.cropperVisible = false;
                this.imageUrl =
                    "/ms-hoc-video/v1/image/download?fileName=" +
                    results[0].originPictureId;
                this.ruleForm.accountHead = results[0].originPictureId;
            } else {
                this.$refs.vueCropper.cropperLoadding = false;
                this.$message({
                    message: "上传头像失败，请稍后再试",
                    customClass: "hos-message--error",
                    iconClass: "el-icon-error",
                    duration: "1000"
                });
            }
        },
        avartIn() {
            this.cropperPrewVisible = true;
        },
        avartDele() {
            this.imageUrl = "";
            this.ruleForm.accountHead = "";
        },
        handleImgClose() {
            this.dialogVisible = false;
        },
        handleAvartClose() {
            this.cropperPrewVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.user-add-wrap-out {
    .doctorAdd-wrap {
        background: #ffffff;
        margin: 20px;
        padding: 20px 20px 0px 20px;
        overflow: hidden;
        box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
        .doctor-title {
            padding-bottom: 8px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px solid #cccccc;
            i {
                color: $color-primary;
            }
            span {
                margin-left: 8px;
            }
        }
        .doctor-base-info {
            border-bottom: 1px solid #cccccc;
            padding-top: 20px;
            .avart-wrap {
                position: relative;
                .avatar-uploader {
                    .avatar-show {
                        width: 118px;
                    }
                    .avatar-img {
                        width: 120px;
                        height: 120px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        position: relative;
                        i {
                            width: 24px;
                            height: 21px;
                            font-size: 20px;
                            color: #ffffff;
                            position: absolute;
                            top: -26px;
                        }
                        div {
                            color: #ffffff;
                            font-size: 14px;
                        }
                        .uploader-title {
                            width: 56px;
                            height: 14px;
                            color: #ffffff;
                            font-size: 14px;
                        }
                    }
                }
                .cover-custom {
                    width: 120px;
                    height: 120px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 888;
                    .cover-wrap {
                        width: 120px;
                        height: 120px;
                        background: rgba(0, 0, 0, 0.4);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        opacity: 0;
                        i {
                            color: #ffffff;
                            font-size: 20px;
                            cursor: pointer;
                        }
                        i:first-child {
                            margin-right: 10px;
                        }
                    }
                }
                .cover-custom:hover .cover-wrap {
                    animation: myfirst 0.5s;
                    -moz-animation: myfirst 0.5s; /* Firefox */
                    -webkit-animation: myfirst 0.5s; /* Safari 和 Chrome */
                    -o-animation: myfirst 1s; /* Opera */
                    animation-fill-mode: forwards; /*ie9 及以下不支持 */
                    -moz-animation-fill-mode: forwards;
                    -webkit-animation-fill-mode: forwards;
                    -o-animation-fill-mode: forwards;
                }
                // ceshi
                @keyframes myfirst {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                @-moz-keyframes myfirst {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                @-webkit-keyframes myfirst {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                @-o-keyframes myfirst {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }
            }
            .form-tips-text {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                line-height: 14px;
                margin: 20px 0;
            }
        }
        .info-title {
            margin-bottom: 20px;
            border-left: 4px solid $color-primary;
            padding-left: 8px;
            height: 16px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 16px;
            color: #333333;
            text-align: left;
            .heart-warning {
                margin-left: 8px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #666666;
                text-align: left;
                line-height: 12px;
            }
        }
        .cert-info {
            .papers-uploader {
                .icon {
                    font-size: 140px;
                }
            }
            .heart-warning {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #999999;
                letter-spacing: 0;
                line-height: 16px;
            }
            .ele-sign {
                .sign-qian {
                    width: 70px;
                    height: 70px;
                    position: relative;
                    .icon {
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                }
            }
        }
        // 标签信息开始
        .set-label {
            border-bottom: none;
            .label-wrap {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                line-height: 14px;
                padding-left: 14px;
                .label-team {
                    margin-bottom: 20px;
                    display: flex;
                    .label-team-left {
                        margin-right: 20px;
                        min-width: 56px;
                        line-height: 18px;
                    }
                    .label-team-right {
                        .label-team-select {
                            // margin-bottom: 10px;
                            color: $color-primary;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            i {
                                font-size: 18px;
                                margin-right: 8px;
                            }
                        }
                        .label-team-content {
                            display: flex;
                            flex-wrap: wrap;
                            .team-content-item {
                                margin-top: 10px;
                                margin-right: 10px;
                                display: flex;
                                align-items: center;
                                height: 24px;
                                padding: 0 10px;
                                border: 1px solid #f2f2f2;
                                border-radius: 3px;
                                color: #333333;
                                .wow-user {
                                    margin-right: 10px;
                                    font-size: 10px;
                                    color: $color-primary;
                                }
                                .wow-close {
                                    margin-left: 10px;
                                    font-size: 6px;
                                    color: #999999;
                                    cursor: pointer;
                                }
                                .wow-folder {
                                    margin-right: 10px;
                                    width: 11px;
                                    height: 11px;
                                    display: inline-block;
                                    background: url("../../../assets/imgs/folder.png")
                                        no-repeat;
                                    background-size: cover;
                                }
                            }
                        }
                    }
                }
            }
        }
        // 标签信息结束
    }
    .add-btn-bottom {
        width: 100%;
        height: 60px;
        background: #f9f9f9;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    // 团队
    .dialog-tema-content {
        padding-right: 10px;
        height: 400px;
        overflow: auto;
        .dialog-tema-item {
            margin-bottom: 14px;
            display: flex;
            justify-content: space-between;
            .dialog-tema-item-left {
                span {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    letter-spacing: 0;
                    line-height: 12px;
                }
            }
            .wow-user {
                margin-right: 10px;
                font-size: 10px;
                color: $color-primary;
            }
        }
    }
    // 无数据
    .dialog-none-data {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon {
            font-size: 80px;
        }
        span {
            line-height: 14px;
            font-size: 12px;
        }
    }
}
</style>
<style lang="scss">
.doctor-base-info {
    .el-textarea__inner {
        padding: 5px 15px 32px 15px !important;
    }
}
// 标签弹窗布局
.el-dialog__wrapper {
    .member-wow-dialog {
        .el-dialog__body {
            padding: 0;
            .member-content {
                height: 453px;
                display: flex;
                .left-wraper {
                    padding-left: 10px;
                    width: 340px;
                    border-right: 1px solid #dcdcdc;
                    .search-content {
                        margin: 10px 0;
                        width: 319px;
                        padding-right: 10px;
                        .search-tema {
                            width: 319px;
                            vertical-align: middle;
                            .el-input__inner {
                                border-radius: 3px;
                                border-color: #dcdcdc;
                                padding: 8px 32px 8px 10px;
                                height: 32px;
                            }

                            .el-input__suffix {
                                background: $color-primary;
                                color: #fff;
                                right: 0;
                                cursor: pointer;
                                border-radius: 0 3px 3px 0;

                                i {
                                    display: inline-block;
                                    width: 36px;
                                    font-size: 14px;
                                    line-height: 32px;
                                    border-radius: 3px;
                                }
                            }
                        }
                    }
                    .table-content {
                        margin-top: 10px;
                    }
                }
                .right-wraper {
                    width: 220px;
                    padding: 20px;
                    padding-right: 0px;
                    overflow: hidden;
                    .content_text {
                        padding-right: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .choose_text {
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #999999;
                            letter-spacing: 0;
                        }
                        .empty_text {
                            cursor: pointer;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #198eeb;
                            letter-spacing: 0;
                        }
                    }
                    .choose-member {
                        height: 396px;
                        padding-right: 20px;
                        overflow: auto;
                        margin-top: 10px;
                        padding-top: 10px;
                        .item-member {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 10px;
                            .icon-user1 {
                                font-size: 14px;
                                color: #06aea6;
                            }
                            .el-icon-close {
                                color: #999;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            .member-text {
                                margin-left: 10px;
                                font-family: PingFangSC-Regular;
                                font-size: 12px;
                                color: #333333;
                                letter-spacing: 0;
                            }
                        }
                    }
                }
            }
        }
        .el-dialog__footer {
            background: #f9f9f9;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            .dialog-footer {
                .dialog-confirm-btn {
                    width: 100px;
                    height: 32px;
                    padding: 0;
                }
                .dialog-cancle {
                    width: 100px;
                    height: 32px;
                    padding: 0;
                    margin-left: 16px;
                }
            }
        }
    }
}
.dialog-tema-content {
    // checkbox
    .el-checkbox-group {
        .el-checkbox {
            display: flex;
            justify-content: space-between;
            flex-flow: row-reverse;
            margin-bottom: 14px;
            margin-right: 0px;
            .el-checkbox__label {
                padding-left: 0px;
                font-size: 12px;
                float: left;
                color: #333333;
                i {
                    margin-right: 10px;
                    font-size: 12px;
                    color: $color-primary;
                }
                .depart-icon {
                    margin-right: 10px;
                }
            }
        }
    }
}
.depart-icon {
    display: inline-block;
    width: 14px;
    height: 12px;
}
</style>
